export default "__VITE_ASSET__ChaOV26q__"